import { OrderStates, useItem, useOnScreen } from "@adamlip/okeoke.client"
import useBasket from "hooks/useBasket"
import { useContext, useRef } from "react"
import "react-swipeable-list/dist/styles.css"
import Item from "./Item"
import { AppParamsContext } from "contexts/AppParamsContext"
import { Spinner } from "@nextui-org/react"

export default function ListItemShell({
  bannedItems,
  itemUUID,
  selectedSizeUUID,
  readOnly,
  menuItemParams,
  isLoading,
  valid,
  disabled,
}) {
  const rootMargin = "0px"
  const ref = useRef(null)
  const onScreen = useOnScreen(ref, rootMargin)
  const { assembledItem } = useItem(itemUUID, selectedSizeUUID)
  const { orderItems, itemCount, orderState } = useBasket()
  //const { setCategoryPageLoaded } = useContext(MainContext);
  const { appParams } = useContext(AppParamsContext)

  // useEffect(() => {
  //   if (onScreen) {
  //     setCategoryPageLoaded(true);
  //   }
  // }, [onScreen]);

  if (assembledItem?.visibleSizes < 1) return null

  return (
    <div
      ref={ref}
      className={`orderItemListItem-placeholder relative overflow-hidden ${
        appParams?.items?.showImage ? "with-img" : "no-img"
      } ${appParams?.styles?.gaps?.itemGap || "mb-4"} ${
        disabled ? "opacity-50" : ""
      }`}
    >
      {(isLoading || assembledItem == null) && (
        <div className="w-full min-h-[110px] flex items-center justify-center bg-[var(--order-items-card-bg-color)]">
          <Spinner />
        </div>
      )}
      {menuItemParams?.onScreenOff == null && !onScreen && (
        <div className="orderItemListItem-root">
          <div className="orderItemListItem-header">
            <div className="orderItemListItem-header-name font-small">
              <div
                style={{
                  width: "130px",
                  height: "16px",
                  borderRadius: "50px",
                  //backgroundColor: "rgba(0, 0, 0, 0.2)",
                  marginBottom: "12px",
                }}
              />
            </div>
            <div className="orderItemListItem-description font-smallest">
              <div
                style={{
                  width: "200px",
                  height: "12px",
                  borderRadius: "50px",
                  //backgroundColor: "rgba(0, 0, 0, 0.2)",
                  marginBottom: "6px",
                }}
              />
              <div
                style={{
                  width: "200px",
                  height: "12px",
                  borderRadius: "50px",
                  //backgroundColor: "rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div className="orderItemListItem-header-price font-small">
              <div
                style={{
                  width: "80px",
                  height: "14px",
                  borderRadius: "50px",
                  //backgroundColor: "rgba(0, 0, 0, 0.2)",
                  marginBottom: "6px",
                }}
              />
            </div>
          </div>
        </div>
      )}
      {((menuItemParams?.onScreenOff == null && onScreen) ||
        menuItemParams?.onScreenOff) &&
        assembledItem != null &&
        assembledItem?.visibleSizes !== 0 && (
          <>
            {appParams?.items?.layoutType !== "3" && (
              <div
                className={`absolute w-1 h-full z-50 left-0 rounded-br-xl rounded-tr-xl ${
                  (orderItems?.some(
                    (item) => item?.itemUUID === assembledItem?.uuid
                  ) &&
                    itemCount > 0 &&
                    orderState === OrderStates.BASKET) ||
                  menuItemParams?.selected
                    ? valid === false
                      ? "!bg-red-600"
                      : " !bg-primary"
                    : "bg-[var(--main-secondary-bg-color)]"
                }`}
              ></div>
            )}
            <Item
              key={itemUUID}
              itemUUID={itemUUID}
              assembledItem={assembledItem}
              readOnly={readOnly}
              banned={(bannedItems || []).includes(itemUUID)}
              menuItemParams={menuItemParams}
            />
          </>
        )}
    </div>
  )
}
